import { render } from "./ImpressumViewWP.vue?vue&type=template&id=bae36360"
import script from "./ImpressumViewWP.vue?vue&type=script&lang=js"
export * from "./ImpressumViewWP.vue?vue&type=script&lang=js"

import "./ImpressumViewWP.vue?vue&type=style&index=0&id=bae36360&lang=scss"

import exportComponent from "E:\\_projekte\\PRIGNITZMUSEUM_HAVELBERG\\ARCHITEKTURSPUR\\release\\architekturspur\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__